import type { InventoryInboundReceiptCreatePayload, InventoryItemResponse, InventoryListResponse } from '@/types/Api/Inventory'
import type { InventoryInboundReceipt } from '@/types/Models/InventoryInboundReceipt'
import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class InventoryInboundReceiptsProxy
  extends BaseProxy
  implements ProxyMethods<InventoryListResponse<InventoryInboundReceipt>>
{
  public endpoint = 'inbound-receipts'
  public hostname = import.meta.env.VITE_APP_INVENTORY_API

  all(): Promise<InventoryListResponse<InventoryInboundReceipt>> {
    return this.submit('get', `${this.hostname}/${this.endpoint}`)
  }

  create(
    item: InventoryInboundReceiptCreatePayload,
  ): Promise<InventoryItemResponse<InventoryInboundReceipt>> {
    return this.submit('post', `${this.hostname}/${this.endpoint}`, item)
  }
}
